
import React, { useState } from 'react';
import {txtA,txtE} from '../../../Label/Lbl';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {useInvCa,useInvMain} from '../../../St/Reviews/UseStyle';
import Paper from '@material-ui/core/Paper';

const BodyCashier = (props) => {
  const {sta,locInv,premiApp,data}=props;
  const clasm = useInvMain();
  const clas = useInvCa();
  const [AE, setAE] = useState(null);
const totalsTitleA_ = () => { return (
  <Grid item container className={clas.BdytotTitle}>
  <Grid item xs={6}className={clasm.minlft} >{txtA.totalAmount}</Grid> 
  <Grid item xs={6} className={clasm.minrit}>{txtE.totalAmount}</Grid>
</Grid>
)}

const totalsTitleE_ = () => { return (
  <Grid item container className={clas.BdytotTitle}>
  <Grid item xs={6}className={clasm.minlft} >{txtE.totalAmount}</Grid> 
  <Grid item xs={6} className={clasm.minrit}>{txtA.totalAmount}</Grid>
</Grid>
)}

const totalsContntA_ = () => { return(
<Grid item container className={clas.BdytotSub}>
  <Grid item xs={8} className={clas.BdytotCntr}>
    <Grid item xs={12}>{sta.StngIA.amountWithVatA}</Grid>
    <Grid item xs={12}>{sta.StngIA.amountWithVatE}</Grid>
  </Grid> 
  <Grid item xs={4} className={clas.BdytotCntrVal}>{sta.tot.amountWithVat?.toFixed(2)}</Grid> 

  <Grid item xs={8} className={clas.BdytotCntr}>
    {sta.StngIA.totdiscountA+' '+sta.StngIA.totdiscountE}
  </Grid> 
  <Grid item xs={4} className={clas.BdytotCntrVal}>{sta.tot.discount?.toFixed(2)}</Grid>  

  <Grid item xs={8} className={clas.BdytotCntr}>
    <Grid item xs={12}>{sta.StngIA.amountWithVat2A}</Grid>
    <Grid item xs={12}>{sta.StngIA.amountWithVat2E}</Grid>
  </Grid> 
  <Grid item xs={4} className={clas.BdytotCntrVal}>{sta.tot.amountWithVat?.toFixed(2)}</Grid>  

  <Grid item xs={8} className={clas.BdytotCntr}>
    <Grid item xs={12}>{sta.StngIA.amountOfVatA}</Grid>
    <Grid item xs={12}>{sta.StngIA.amountOfVaEt}</Grid>
  </Grid> 
  <Grid item xs={4} className={clas.BdytotCntrVal}>{sta.tot.amountOfVat?.toFixed(2)}</Grid>  

  <Grid item xs={8} className={clas.BdytotCntr}>
    <Grid item xs={12}>{sta.StngIA.tot_netA}</Grid>
    <Grid item xs={12}>{sta.StngIA.tot_netE}</Grid>
  </Grid> 
  <Grid item xs={4} className={clas.BdytotCntrVal}>{sta.tot.tot_net?.toFixed(2)}</Grid>  
</Grid>
)}

const totalsContntE_ = () => { return(
  <Grid item container className={clas.BdytotSub}>
 
    <Grid item xs={4} className={clas.BdytotCntrVal}>{(sta.tot.tot_net-sta.tot.amountOfVat+sta.tot.discount).toFixed(2)}</Grid> 
    <Grid item xs={8} className={clas.BdytotCntr}>
      <Grid item xs={12}>{txtA.amountWithVat}</Grid>
      <Grid item xs={12}>{txtE.amountWithVat}</Grid>
    </Grid> 
  
    <Grid item xs={4} className={clas.BdytotCntrVal}>{sta.tot?.discount?.toFixed(2)}</Grid>  
    <Grid item xs={8} className={clas.BdytotCntr}>{txtE.totdiscount+' '+txtA.totdiscount}</Grid> 
  
    <Grid item xs={4} className={clas.BdytotCntrVal}>{(sta.tot.tot_net-(sta.tot.amountOfVat))?.toFixed(2)}</Grid>  
    <Grid item xs={8} className={clas.BdytotCntr}>
      <Grid item xs={12}>{txtA.amountWithVat2}</Grid>
      <Grid item xs={12}>{txtE.amountWithVat2}</Grid>
    </Grid> 
  
    <Grid item xs={4} className={clas.BdytotCntrVal}>{sta.tot.amountOfVat?.toFixed(2)}</Grid>  
    <Grid item xs={8} className={clas.BdytotCntr}>
      <Grid item xs={12}>{txtA.amountOfVat}</Grid>
      <Grid item xs={12}>{txtE.amountOfVat}</Grid>
    </Grid> 
  
    <Grid item xs={4} className={clas.BdytotCntrVal}>{sta.tot.tot_net?.toFixed(2)}</Grid>  
    <Grid item xs={8} className={clas.BdytotCntr}>
      <Grid item xs={12}>{txtA.tot_net}</Grid>
      <Grid item xs={12}>{txtE.tot_net}</Grid>
    </Grid> 

  </Grid>
  )}

return (
  <Grid item container className={clas.Bdyroot}>

    <Grid item container className={clas.BdyundrHeaderTF}>
      { locInv.ProcTypeInvProc != "03" && 
        <Grid item xs={12} className={clas.BdytitleHed}>
         {/* <Typography className={[clas.contnt,clasm.minclr]}>{sta.StngIA.titleFatoraA}</Typography> */}
         <Typography className={[clas.contnt,clasm.minclr]}>{sta.tot.tax_no_cust===""?"فاتورة ضريبية مبسطة":"فاتورة ضريبية"}</Typography>
        </Grid>
      }

      <Grid item xs={12} className={[clas.BdytitleHedDw,clas.BdytitleHed]}>
        <Typography className={[clas.contnt,clasm.minclr]}>{locInv.invN+" "+sta.tot.inv_type_name+" "+ sta.tot.pay_type_name}</Typography>
      </Grid>
    </Grid>

    <Grid item container className={clas.Bdycntr}>
      { !sta.StngIA.showColDHd && !premiApp.stayWCa
       ? <Grid item xs={4} className={clas.BdyborBtR}>{txtE.invNumr}</Grid> : <Grid item xs={4}></Grid> }
    <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}><Paper className={clasm.minclr}>{sta.tot.id}</Paper></Grid>
    <Grid item xs={sta.StngIA.ncol} className={clas.BdyborBtL}>{txtA.invNumr}</Grid>
    <Grid item xs={4}></Grid>
    
    <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}><Paper className={clasm.minclr}>{sta.tot?.refno}</Paper></Grid>
    <Grid item xs={sta.StngIA.ncol} className={clas.BdyborBtL}>{'رقم المرجع'}</Grid>
    { !sta.StngIA.showColDHd && !premiApp.stayWCa
       ? <Grid item xs={4} className={clas.BdyborBtR}>{txtE.invDate}</Grid> : null }
    <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}><Paper className={clasm.minclr}>{moment(sta.tot.date).format('YYYY/MM/DD')}</Paper></Grid>
    {!premiApp.stayWCa? <Grid item xs={sta.StngIA.ncol} className={clas.BdyborBtL}>{txtA.invDate}</Grid>: null}

    { !sta.StngIA.showColDHd && !premiApp.stayWCa
       ? <Grid item xs={4} className={clas.BdyborBtR}>{txtE.time}</Grid> : null }
    <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}><Paper className={clasm.minclr}>{moment(sta.tot.date).format('hh:mm A')}</Paper></Grid>
    {!premiApp.stayWCa? <Grid item xs={sta.StngIA.ncol} className={clas.BdyborBtL}>{txtA.time}</Grid>:null}

    { !sta.StngIA.showColDHd && !premiApp.stayWCa
       ? <Grid item xs={4} className={clas.BdyborBtR}>{txtE.custmName}</Grid> : null }
    {!premiApp.stayWCa? <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}><Paper className={clasm.minclr}>{sta.tot.cust_name}</Paper></Grid>: null}
    {!premiApp.stayWCa? <Grid item xs={sta.StngIA.ncol} className={clas.BdyborBtL}>{txtA.custmName}</Grid>: null}

    { !sta.StngIA.showColDHd && !premiApp.stayWCa
       ? <Grid item xs={4} className={clasm.minborR}>{txtE.taxNumr}</Grid> : null }
    {!premiApp.stayWCa? <Grid item xs={sta.StngIA.ncol} ><Paper className={clasm.minclr}>{sta.tot.tax_no_cust}</Paper></Grid>:null}
    {!premiApp.stayWCa? <Grid item xs={sta.StngIA.ncol} className={clasm.minborL}>{txtA.taxNumr}</Grid>:null}
    </Grid>

    <Grid item container className={clas.Bdytabl}>

      <Grid item xs={5}>{txtE.subTotalWithVat}</Grid>
      <Grid item xs={2}>{txtE.discount}</Grid>
      <Grid item xs={2}>{txtE.Quantity}</Grid>
      <Grid item xs={3}>{txtE.unitPrice}</Grid>

      <Grid item xs={5}>{txtA.subTotalWithVat}</Grid>
      <Grid item xs={2}>{txtA.discount}</Grid>
      <Grid item xs={2}>{txtA.Quantity}</Grid>
      <Grid item xs={3}>{txtA.unitPrice}</Grid>

    </Grid>

    <Grid item container className={clas.Bdyrows}>
      {data.map((item,i)=>
        <Grid item container key={i}>
          <Grid item className={clas.Bdyrow} xs={5}>{item.netTotal}</Grid>
          <Grid item className={clas.Bdyrow} xs={2}>{item.discount}</Grid>
          <Grid item className={clas.Bdyrow} xs={2}>{item.val1}</Grid>
          <Grid item className={clas.Bdyrow} xs={3}>{item.priceC}</Grid>
          <Grid item className={clas.BdyrowSy} xs={12}>{item.symbol}</Grid> 


        </Grid>
      )}
    </Grid>

  

{AE ?totalsTitleA_():totalsTitleE_()}
{AE ?totalsContntA_():totalsContntE_()}

</Grid>
    );
}
export default BodyCashier

